import { render } from "./UserDashboard.vue?vue&type=template&id=77e1faae&scoped=true"
import script from "@/assets/js/UserDashboard.js?vue&type=script&defer=true&lang=js&external"
export * from "@/assets/js/UserDashboard.js?vue&type=script&defer=true&lang=js&external"

import "@/assets/css/UserDashboard.css?vue&type=style&index=0&id=77e1faae&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e1faae"]])

export default __exports__